(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoxo-header"]) return;
  try {
    
function setupHoxoNavigation(root = document) {
  root.querySelectorAll('[data-hoxo-navigation]').forEach(nav => {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const media = window.matchMedia('(min-width: 901px)');
    const resize = () => { nav.open = media.matches; };
    resize(); media.addEventListener('change', resize);
    nav.querySelectorAll('.hx-nav-group').forEach(group => group.addEventListener('toggle', () => {
      if (group.open) nav.querySelectorAll('.hx-nav-group').forEach(other => { if (other !== group) other.open = false; });
    }));
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const current = event.target.closest('.hx-nav-group');
        if (current) { current.open = false; current.querySelector('summary').focus(); }
        else if (!media.matches) { nav.open = false; nav.querySelector('summary').focus(); }
      }
    });
    document.addEventListener('click', event => { if (!nav.contains(event.target)) nav.querySelectorAll('.hx-nav-group').forEach(group => group.open = false); });
  });

}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupHoxoNavigation());
else setupHoxoNavigation();
document.addEventListener('shopify:section:load', event => setupHoxoNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoxo-home"] && !Shopify.designMode) return;
  try {
    
function initializeHoxoFinders(root = document) {
  root.querySelectorAll('[data-hoxo-finder]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const brand = form.querySelector('[data-brand]');
    const model = form.querySelector('[data-model]');
    const options = Array.from(model.options).map(option => option.cloneNode(true)).sort((a, b) => !a.value ? -1 : !b.value ? 1 : (window.hoxoModelCompare ? window.hoxoModelCompare(a.textContent,b.textContent) : b.textContent.localeCompare(a.textContent, undefined, { numeric: true, sensitivity: 'base' })));
    function syncModels() {
      model.replaceChildren(...options.filter(option => !option.value || option.dataset.brand === brand.value).map(option => option.cloneNode(true)));
      model.disabled = !brand.value;
    }
    brand.addEventListener('change', syncModels);
    form.addEventListener('submit', event => {
      const option = model.selectedOptions[0];
      if (!brand.value || !model.value) { event.preventDefault(); return; }
      if (option.dataset.url) { event.preventDefault(); window.location.assign(option.dataset.url); }
    });
    syncModels();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeHoxoFinders());
else initializeHoxoFinders();
document.addEventListener('shopify:section:load', event => initializeHoxoFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoxo-slideshow"] && !Shopify.designMode) return;
  try {
    
function setupHoxoSlides(root=document){root.querySelectorAll('[data-hoxo-slideshow]').forEach(el=>{
 if(el.dataset.ready)return;el.dataset.ready='true';const slides=[...el.querySelectorAll('[data-hoxo-slide]')],dots=[...el.querySelectorAll('[data-hoxo-dot]')];let index=0,timer,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const pause=el.querySelector('[data-hoxo-pause]');
 const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));};
 const stop=()=>clearInterval(timer);const start=()=>{stop();if(!paused&&slides.length>1&&!document.hidden)timer=setInterval(()=>show(index+1),6000);};
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
 el.querySelector('[data-hoxo-prev]').addEventListener('click',()=>{show(index-1);start();});el.querySelector('[data-hoxo-next]').addEventListener('click',()=>{show(index+1);start();});
 pause.setAttribute('aria-pressed',String(paused));pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ';start();});
 el.addEventListener('mouseenter',stop);el.addEventListener('mouseleave',start);el.addEventListener('focusin',stop);el.addEventListener('focusout',e=>{if(!el.contains(e.relatedTarget))start();});document.addEventListener('visibilitychange',start);
 document.addEventListener('shopify:block:select',e=>{const n=slides.findIndex(s=>s.contains(e.target)||s===e.target);if(n>=0){show(n);stop();}});start();
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setupHoxoSlides());else setupHoxoSlides();document.addEventListener('shopify:section:load',e=>setupHoxoSlides(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
